import { render, staticRenderFns } from "./u-scrolldown-filled.vue?vue&type=template&id=71be8a14&scoped=true"
import script from "./u-scrolldown-filled.vue?vue&type=script&lang=js"
export * from "./u-scrolldown-filled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be8a14",
  null
  
)

export default component.exports